import { ConfigProvider } from 'antd';
import { FC, ReactNode } from 'react';

const theme = {
  token: {
    fontFamily: 'Inter, sans-serif',
    colorPrimary: '#6706f9',
    colorLink: '#6706f9',
    colorLinkActive: '#4904b1',
    colorLinkHover: '#9762fb',
    fontWeightStrong: 500,
  },
};

interface AntdConfigProviderProps {
  children: ReactNode;
}

export const AntdConfigProvider: FC<AntdConfigProviderProps> = ({
  children,
}) => {
  return <ConfigProvider theme={theme}>{children}</ConfigProvider>;
};
